// Call right after an API call actually succeeds, before showing the
// success message / redirecting. GTM listens for these events and handles
// the GA4 / Google Ads conversions.
export function pushDataLayerEvent(event: string) {
  // @ts-ignore
  window.dataLayer = window.dataLayer || [];
  // @ts-ignore
  window.dataLayer.push({ event });
}
